/**
 * SeloPrompt — o selo do membro do squad (SPEC A2 FR-7).
 *
 * Deriva SÓ da conferência (`GET /projects/{id}/squad-design/conferencia`, FR-6):
 *   ✅ especialista · ⚠️ sem prompt de especialista · ⚠️ incompleto · ⚠️ conflito com regras
 * e um selo extra por skill sem conteúdo (AG-14). Membro ainda não conferido (design não
 * salvo) mostra "não conferido" — nunca um ✅ presumido.
 *
 * Paleta C, estilos inline, pt-BR.
 */
import { C } from '@/theme/palette';
import { seloDoMembro, TEXTO_DO_SELO } from './comum';

function Pilula({ cor, children, title, testId }) {
  return (
    <span
      data-testid={testId}
      title={title}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        fontSize: 10.5, fontWeight: 600, padding: '2px 7px', borderRadius: 5,
        color: cor, background: `${cor}18`, border: `1px solid ${cor}55`,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </span>
  );
}

/**
 * @param {{ membro: object|null|undefined, agent?: string, compacto?: boolean }} props
 *   membro — item de `conferencia.membros` (ou null se ainda não conferido).
 */
export function SeloPrompt({ membro, agent, compacto = false }) {
  const slug = membro?.agent ?? agent ?? '';
  const selo = seloDoMembro(membro);
  if (!selo) {
    return (
      <Pilula cor={C.neutralMuted} testId={`selo-${slug}`}
        title="Salve a composição para conferir o prompt deste membro.">
        · não conferido
      </Pilula>
    );
  }
  const cor = selo === 'especialista' ? C.cyber : C.warn;
  const titulo = membro?.prompt
    ? `Prompt ${membro.prompt.status ?? '—'} · ${membro.prompt.chars ?? 0} caracteres`
      + ((membro.prompt.faltando || []).length ? ` · faltando: ${membro.prompt.faltando.join(', ')}` : '')
    : undefined;
  const semConteudo = (membro?.skills || []).filter((s) => s && s.tem_conteudo === false);
  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 4 }}>
      <Pilula cor={cor} testId={`selo-${slug}`} title={titulo}>
        {TEXTO_DO_SELO[selo] ?? selo}
      </Pilula>
      {membro?.status_catalogo === 'rascunho' && (
        <Pilula cor={C.warn} title="Agente fora do catálogo — entrou como rascunho.">rascunho</Pilula>
      )}
      {!compacto && semConteudo.map((s) => (
        <Pilula key={s.name} cor={C.warn}>⚠️ skill sem conteúdo: {s.name}</Pilula>
      ))}
    </span>
  );
}
